import React from 'react';
import { createPortal } from 'react-dom';

export default function Modal({
    id,
    modal,
    children,
    parentContainerClasses = '',
    innerContainerClasses = '',
    modalIndexClass = 'tw-z-50',
    containerStyle = {},
}) {
    if (!modal) {
        return null;
    }

    return createPortal(
        <div id={id} ref={modal.ref} className={`hidden modal__box ${modalIndexClass}`} aria-hidden="true">
            <div className={`modal__container ${parentContainerClasses}`} style={containerStyle}>
                <div className={`modal__inner-container ${innerContainerClasses}`}>{children}</div>
            </div>
        </div>,
        document.body,
    );
}
